import React from 'react';
import { PropInfo, CodeExample, PaginationProps } from '@cimpress/react-components';

import PaginationCode from '!raw-loader!./pagination.jsx';
import PaginationDemo from './pagination.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const PaginationDocs = () => {
  const propInfos: PropInfo<PaginationProps>[] = [
    {
      name: 'pageCount',
      type: 'number (required)',
      default: '',
      description: 'Defines the total number of pages available.',
    },
    {
      name: 'onPageChange',
      type: 'function (required)',
      default: '',
      description: (
        <div>
          <p>Callback function that is triggered when a new page number is selected. </p>
          <p>
            Signature: <code>function(&#123; selected: number &#125;) {'=>'} void</code>{' '}
          </p>
          <p>
            <code>selected:</code> The 0-based page number that was selected. If page <code>1</code> is selected, this
            value will be <code>0</code>.
          </p>
        </div>
      ),
    },
    {
      name: 'initialPage',
      type: 'number',
      default: '0',
      description: 'The initial page that is selected in the component.',
    },
    {
      name: 'pagesOutsideElipses',
      type: 'number',
      default: '1',
      description: (
        <p>
          The number of pages displayed to the left and right of the <code>...</code> boxes.{' '}
        </p>
      ),
    },
    {
      name: 'pagesBetweenElipses',
      type: 'number',
      default: '3',
      description: (
        <p>
          The number of pages displayed between the <code>...</code> boxes. Only updates on odd number inputs. (i.e. 6
          will show 7 boxes)
        </p>
      ),
    },
  ];

  return (
    <div>
      <ComponentDoc
        name="Pagination"
        propInfos={propInfos}
        remarks={
          <p>
            All other props not enumerated here will be passed to the underlying pagination component -- see the{' '}
            <a href="https://github.com/AdeleD/react-paginate" target="_blank" rel="noopener noreferrer">
              react-paginate docs
            </a>{' '}
            to see more options.
          </p>
        }
      >
        <PaginationDemo />
        <CodeExample code={PaginationCode} />
      </ComponentDoc>
    </div>
  );
};

export default PaginationDocs;
